@if (error$ | async) {
  <hyperkit-message class="error" type="error"></hyperkit-message>
} @else {
  @if (collections$ | async; as collectionData) {
    <cyborg-section>
      @if (collectionData.emergingThreats; as emergingThreats) {
        <div id="emerging-threats">
          @for (collection of emergingThreats; track collection) {
            <cyborg-collection [data]="collection" [highlighting]="false">
            </cyborg-collection>
          }
        </div>
      }
    </cyborg-section>
  } @else {
    <div class="loading">
      <kendo-loader type="pulsing" themeColor="primary" size="large">
      </kendo-loader>
    </div>
  }
}
